// components/OrganisationConsumptionTimeline.tsx
'use client';

import React from 'react';
import ConsumptionTimeline from './ui/ConsumptionTimeline';

interface OrganisationConsumptionTimelineProps {
  organisationId: string;
  organisationName: string;
}

const OrganisationConsumptionTimeline: React.FC<OrganisationConsumptionTimelineProps> = ({
  organisationId,
  organisationName,
}) => (
  <ConsumptionTimeline
    endpoint={`/api/organisation/analytics/consumption?orgId=${organisationId}`}
    scopeName={organisationName}
    csvPrefix="fater_consumption_"
    emptyLabel="No usage data for this period."
    fetchErrorLabel="Failed to fetch consumption analytics:"
  />
);

export default React.memo(OrganisationConsumptionTimeline);
